import { fileFormat } from "./fileUtils";

export const base64ToFile = async (base64: string, fileName: string) => {
  const blob: any = await fetch(base64).then(response => response.blob());
  blob.lastModifiedDate = new Date();
  blob.name = fileName;

  return blob.slice(0, blob.size, fileFormat(base64)) as File;
};

export const blobToBase64 = (blob: Blob): Promise<string> => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
  });
};
